import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { SEQUENCES_LIST_KEY } from './useSequencesFolders';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useLimitReached } from '@teetsh/app/src/components/LimitReached/useLimitReached';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export default function useDuplicateSequence() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { openLimitModal } = useLimitReached();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation({
    mutationFn: (sequenceId: string) =>
      request(`/sequences/${sequenceId}/duplicate`, {
        method: 'POST',
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 403) {
        openLimitModal({
          requiredPlan: (err?.response as any)?.data?.requiredPlan,
          limit: (err?.response as any)?.data?.limit,
        });
        return;
      }
      notifyError({
        title: t('sequence:messages.sequence.createError'),
      });
    },
  });
  return mutateAsync;
}
